import { DEFAULT_STYLE_VALUES } from './converters/StyleAttributes';

// fixed quill function, properly returns common formats (never any arrays)
/* eslint-disable no-param-reassign */
export function combineFormatsCommon(formats, combined) {
    return Object.keys(combined).reduce((merged, name) => {
        if (formats[name] == null) {
            formats[name] = DEFAULT_STYLE_VALUES[name];
        }

        if (combined[name] === formats[name]) {
            merged[name] = combined[name];
        }
        return merged;
    }, {});
}
/* eslint-enable no-param-reassign */

// quill function modified to be inclusive (return all formats in selection)
/* eslint-disable no-param-reassign */
export function combineFormatsAll(formats, combined) {
    return Object.keys(combined).reduce((merged, name) => {
        if (formats[name] == null) {
            formats[name] = DEFAULT_STYLE_VALUES[name];
        }

        if (combined[name] === formats[name]) {
            merged[name] = [combined[name]];
        } else if (Array.isArray(combined[name])) {
            merged[name] = combined[name];
            if (combined[name].indexOf(formats[name]) < 0) {
                merged[name] = combined[name].concat([formats[name]]);
            }
        }
        return merged;
    }, {});
}
/* eslint-enable no-param-reassign */

export interface BlockAttributes {
    line: Record<string, any>;
    leaves: Record<string, any>[];
}

export function combineNodes(blocks: BlockAttributes[], combiner: (formats, combined) => any) {
    let allBlockFormats;
    let allLeafFormats;

    blocks.forEach((block) => {
        const currentBlockFormats = { ...block.line };
        block.leaves.forEach((leaf) => {
            const currentLeafFormats = { ...leaf };

            // If a leaf doesn't have it's own inline style for something, grab it from the parent block
            if (!currentLeafFormats.color) {
                currentLeafFormats.color = currentBlockFormats.blockColor;
            }
            if (!currentLeafFormats.fontSize) {
                currentLeafFormats.fontSize = currentBlockFormats.blockFontSize;
            }
            if (!currentLeafFormats.fontFamily) {
                currentLeafFormats.fontFamily = currentBlockFormats.blockFontFamily;
            }
            if (!currentLeafFormats.casing) {
                currentLeafFormats.casing = currentBlockFormats.blockCasing;
            }
            if (!currentLeafFormats.lineHeight) {
                currentLeafFormats.lineHeight = currentBlockFormats.blockLineHeight;
            }
            if (!currentLeafFormats.letterspacing) {
                currentLeafFormats.letterspacing = currentBlockFormats.blockLetterspacing;
            }
            if (!currentLeafFormats.fontWeight) {
                currentLeafFormats.fontWeight = currentBlockFormats.blockFontWeight;
            }
            if (!currentLeafFormats.fontStyle) {
                currentLeafFormats.fontStyle = currentBlockFormats.blockFontStyle;
            }
            if (!currentLeafFormats.textDecoration) {
                currentLeafFormats.textDecoration = currentBlockFormats.blockTextDecoration;
            }
            if (!currentLeafFormats.strokeColor) {
                currentLeafFormats.strokeColor = currentBlockFormats.blockStrokeColor;
            }
            if (!currentLeafFormats.strokeOverprints) {
                currentLeafFormats.strokeOverprints = currentBlockFormats.blockStrokeOverprints;
            }
            if (!currentLeafFormats.strokeThickness) {
                currentLeafFormats.strokeThickness = currentBlockFormats.blockStrokeThickness;
            }
            if (!currentLeafFormats.strokePosition) {
                currentLeafFormats.strokePosition = currentBlockFormats.blockStrokePosition;
            }
            if (!currentLeafFormats.overprints && currentBlockFormats.blockOverprints) {
                currentLeafFormats.overprints = currentBlockFormats.blockOverprints;
            }

            if (!allLeafFormats) {
                allLeafFormats = currentLeafFormats;
            }

            allLeafFormats = combiner(currentLeafFormats, allLeafFormats);
        });

        // We don't need the block-level values in this output since they get stored on the leaves above
        delete currentBlockFormats.blockColor;
        delete currentBlockFormats.blockFontFamily;
        delete currentBlockFormats.blockFontSize;
        delete currentBlockFormats.blockCasing;
        delete currentBlockFormats.blockLineHeight;
        delete currentBlockFormats.blockLetterspacing;
        delete currentBlockFormats.blockFontWeight;
        delete currentBlockFormats.blockFontStyle;
        delete currentBlockFormats.blockTextDecoration;
        delete currentBlockFormats.blockStrokeColor;
        delete currentBlockFormats.blockStrokeOverprints;
        delete currentBlockFormats.blockStrokeThickness;
        delete currentBlockFormats.blockStrokePosition;
        delete currentBlockFormats.blockOverprints;

        if (!allBlockFormats) {
            allBlockFormats = currentBlockFormats;
        }

        allBlockFormats = combiner(currentBlockFormats, allBlockFormats);
    });

    return [allBlockFormats, allLeafFormats];
}
